import { useContext } from "react";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";
import ExportExcelButton from "./ExportButton";
import ExportZipButton from "./ExportZipButton";
import * as FaIcons from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getReactAppUrl } from "../../functions/getEnv";
import AuthContext from "../../context/auth/authContext";
import SearchForm from "./SearchForm";
import { toast } from "react-toastify";

const FormToggles = ({ onOpenFilterSidebar, onOpenColumnManager, selectedSession, selectedSessionId }) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;

  const adminLeloContext = useContext(AdminLeloContext);
  const {
    LeloListStatus,
    appliedFilters,
    searchFilter,
    clearSearchFilter,
    startDate,
    endDate,
    listView,
    setListView,
  } = adminLeloContext;

  const appUrl = getReactAppUrl(import.meta.env.VITE_NODE_ENV);
  const navigate = useNavigate();

  const { inactive, active, signed } = LeloListStatus;

  // Function to get current filter parameters for export
  const getCurrentFilters = () => {
    let status = null;
    if (active) status = "Active";
    else if (inactive) status = "Inactive";
    else if (signed) status = "Signed";

    // Use appliedFilters if available
    if (appliedFilters && appliedFilters.status) {
      status = appliedFilters.status;
    }

    return {
      status,
      ...(appliedFilters?.permaLink && { permaLink: appliedFilters.permaLink }),
      ...(startDate && endDate && {
        startDate: new Date(startDate),
        endDate: (() => {
          const end = new Date(endDate);
          end.setHours(23, 59, 59);
          return end;
        })()
      })
    };
  };

  const handlePreRegistrationClick = () => {
    if (selectedSession && selectedSessionId) {
      navigate(`/pre-forms/${selectedSession}/${selectedSessionId}`);
    } else {
      toast.error("Please select a session from Filters before creating a new pre-registration.");
      // Open filter sidebar to select session
      onOpenFilterSidebar();
    }
  };

  // Check if signed status is active
  const isSignedStatus = signed || (appliedFilters && appliedFilters.status === "Signed");

  return (
    <div className="list-toolbar-container">
      <div className="list-toolbar">
        {/* Search Form */}
        <SearchForm
          placeholderText="Search by name, email, phone..."
          searchFilter={searchFilter}
          clearSearchFilter={clearSearchFilter}
        />
        {user &&
          (user.userStatus === "Contributor" ||
            user.userStatus === "Admin" ||
            user.userStatus === "Super Admin") && (
            <button
              className="toolbar-btn pre-reg-btn"
              onClick={handlePreRegistrationClick}
              title="New Pre Registration (Select session from Filters first)"
            >
              <FaIcons.FaPlus />
              New Pre Registration
            </button>
          )}

        {/* Filters Button */}
        <button
          className="toolbar-btn filter-btn"
          onClick={onOpenFilterSidebar}
          title="Open Filters"
        >
          <FaIcons.FaFilter />
          Filters
        </button>

        {/* Columns Button */}
        <button
          className="toolbar-btn columns-btn"
          onClick={onOpenColumnManager}
          title="Manage Columns"
        >
          <FaIcons.FaColumns />
          Columns
        </button>

        {/* List View Button */}
        <div className="toolbar-btn-group">
        <button
          className={`toolbar-btn view-btn ${listView ? 'active' : ''}`}
          onClick={() => setListView(true)}
          title="List View"
        >
          <FaIcons.FaList />
        </button>

        {/* Grid View Button */}
        <button
          className={`toolbar-btn view-btn ${!listView ? 'active' : ''}`}
          onClick={() => setListView(false)}
          title="Grid View"
        >
          <FaIcons.FaThLarge />
        </button>
        </div>

        {/* New Pre Registration Button */}


        {/* Export Excel Button */}
        <ExportExcelButton
          getCurrentFilters={getCurrentFilters}
          appUrl={appUrl}
        />

        {/* Export Zip Button - Only show when Signed status */}
        {isSignedStatus && (
          <ExportZipButton
            getCurrentFilters={getCurrentFilters}
            appUrl={appUrl}
          />
        )}
      </div>
    </div>
  );
};

export default FormToggles;
